import { render } from "./Feature.vue?vue&type=template&id=56b568fc"
import script from "./Feature.vue?vue&type=script&lang=js"
export * from "./Feature.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__